import { render, staticRenderFns } from "./ReconocimientoColaboradores.vue?vue&type=template&id=03eada02&scoped=true&"
import script from "./ReconocimientoColaboradores.vue?vue&type=script&lang=js&"
export * from "./ReconocimientoColaboradores.vue?vue&type=script&lang=js&"
import style0 from "./ReconocimientoColaboradores.vue?vue&type=style&index=0&id=03eada02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eada02",
  null
  
)

export default component.exports